import { useNavigate } from "react-router-dom";
import RevAudTable from "src/components/pages/Summary/ReviewsAndAudits/RevAudTable";
import useGetRevAud from "src/components/pages/Summary/ReviewsAndAudits/useGetRevAud";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "src/components/shared/Button/Button";
import { useCheckPerm, useIsOnline } from "src/hooks";
import { ButtonWrapper } from "src/pages/Settings/AccountDetails/AccountDetails.styled";
import { useSelector } from "src/redux/hooks";
import { PageContainer } from "src/styled";

const Reviews = () => {
  const navigate = useNavigate();
  const isOnline = useIsOnline();
  const checkPerm = useCheckPerm();
  const yachtuser = useSelector(state => state.permsSlice.yachtuser);

  const { data, refetch, isLoading } = useGetRevAud(
    yachtuser ? "get-reviews" : "get-reviews-flag",
  );
  return (
    <PageContainer>
      <Breadcrumbs
        customLinks={!yachtuser ? links => links.slice(2) : undefined}
        border={false}>
        <ButtonWrapper>
          {checkPerm("review") && (
            <Button
              onClick={() => navigate("/summary/reviews/create-review")}
              disabled={!isOnline}>
              Create
            </Button>
          )}
        </ButtonWrapper>
      </Breadcrumbs>
      <RevAudTable data={data ?? []} refetch={refetch} loading={isLoading} />
    </PageContainer>
  );
};

export default Reviews;
